import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { DEFERRED_METHODS } from "../saleStatus";
import "./pos-modal.css";

const MAX_INSTALLMENTS = 6;

const METHOD_LABEL = {
  credit_card: "Cartão de crédito",
  pix: "PIX",
  money: "Dinheiro",
};

export default function InstallmentModal({
  isOpen,
  onClose,
  total,
  paymentMethod,
  onConfirm,
}) {
  const options = Array.from({ length: MAX_INSTALLMENTS }, (_, i) => i + 1);

  const handleSelect = (n) => {
    onConfirm(n);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="sm" className="pos-modal">
      <div className="modal-header">
        <span className="modal-title">
          Parcelamento — {METHOD_LABEL[paymentMethod] ?? paymentMethod}
        </span>
        <button className="pos-modal-close-btn" onClick={onClose}>
          ×
        </button>
      </div>

      <ModalBody>
        {DEFERRED_METHODS.includes(paymentMethod) && (
          <p className="pos-installment-note">
            À vista (1×) entra como <strong>Pago</strong>. Parcelado fica{" "}
            <strong>Pendente</strong> até as parcelas serem baixadas no
            Financeiro (botão $ em Vendas).
          </p>
        )}
        <div className="pos-installment-grid">
          {options.map((n) => {
            const value = total > 0 ? total / n : 0;
            return (
              <button
                key={n}
                className="pos-installment-btn"
                onClick={() => handleSelect(n)}
              >
                <span className="pos-installment-n">{n}×</span>
                {total > 0 && (
                  <span className="pos-installment-value">
                    R${" "}
                    {value.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                )}
                <span className="pos-installment-tag">sem juros</span>
              </button>
            );
          })}
        </div>
      </ModalBody>

      <ModalFooter>
        <button
          className="pos-modal-btn pos-modal-btn--secondary"
          onClick={onClose}
        >
          Cancelar
        </button>
      </ModalFooter>
    </Modal>
  );
}
